import { useState } from "react";
import styles from "./TempleCard.module.css";
import { FaMapMarkerAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import LightTooltip from "../tooltip/LightTooltip";
import Heart from "../heart/Heart";
import { cookies } from "../../axios";
import { no_image } from "../../controller/image";

const TempleCard = ({ temple, isWishlisted, onWishlist, from , isGroupWidget}) => {
  const userCookie = cookies.get("userDetails");
  const userDetails = userCookie || null;
  const user_type = userDetails?.user_type;
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!temple) return null;

  const handleCardClick = () => {
    navigate(`/view-temple/${temple.id}`);
  };
  const handleNavigate = (groupID, groupName) => {
    navigate(`/ViewAllTemples`, {
      state: {
        groupID: groupID,
        groupName: groupName,
      },
    });
  };

  const handlePrev = (e) => {
    e.stopPropagation(e);
    setCurrentIndex((prev) =>
      prev === 0 ? temple.image.length - 1 : prev - 1,
    );
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) =>
      prev === temple.image.length - 1 ? 0 : prev + 1,
    );
  };

  const handleWishlistClick = (e) => {
    e.stopPropagation();
    if (user_type === 2) {
      onWishlist(temple.id);
    } else {
      cookies.remove("userDetails", { path: "/" });
      localStorage.removeItem("appLanguage");
      navigate("/login");
    }
  };

  const handleDotClick = (e, index) => {
    e.stopPropagation();
    setCurrentIndex(index);
  };

  return (
    <div
      className={styles.card}
      onClick={() => {
        from === "dashBoard"
          ? handleNavigate(temple.group_id, temple?.group_name)
          : handleCardClick();
      }}
      style={{ cursor: "pointer" }}
    >
      {/* Wishlist Heart (with animation handled inside Heart.js) */}
      {user_type !== 1 && !isGroupWidget && (
        <div className={styles.heartBtn}>
          <Heart value={isWishlisted} onClick={handleWishlistClick} />
        </div>
      )}
      {/* Image Slider */}
      <div className={styles.imageWrapper}>
        {temple?.image?.length > 0 ? (
          <img
            src={temple?.image[currentIndex]?.image}
            alt={temple?.name}
            className={styles.image}
          />
        ) : (
          <img src={no_image} alt={temple?.name} className={styles.image} />
        )}

        {(temple.image?.length || 0) > 1 && (
          <>
            {currentIndex > 0 && (
              <button
                className={`${styles.navBtn} ${styles.left}`}
                onClick={handlePrev}
              >
                <FaChevronLeft />
              </button>
            )}
            {currentIndex < temple.image.length - 1 && (
              <button
                className={`${styles.navBtn} ${styles.right}`}
                onClick={handleNext}
              >
                <FaChevronRight />
              </button>
            )}
          </>
        )}

        {/* Dots */}
        <div className={styles.dots}>
          {temple.image?.map((_, index) => (
            <span
              key={index}
              className={`${styles.dot} ${
                index === currentIndex ? styles.activeDot : ""
              }`}
              onClick={(e) => handleDotClick(e, index)}
            />
          ))}
        </div>
      </div>

      {/* Details */}
      <div className={styles.details}>
        {temple?.group_name && (
          <LightTooltip title={temple?.group_name || ""}>
            <h3 className={`mb-1 ${styles.templeName}`}>
              {temple?.group_name}
            </h3>
          </LightTooltip>
        )}

        {temple?.temple_name && (
          <LightTooltip title={temple?.temple_name || ""}>
            <h3 className={`mb-1 ${styles.templeName}`}>
              {temple?.temple_name}
            </h3>
          </LightTooltip>
        )}

        {temple?.address && (
          <LightTooltip title={temple?.address || ""}>
            <p className={`mb-1 ${styles.location}`}>
              <FaMapMarkerAlt className={styles.locationIcon} />
              <span className={styles.locationText}>{temple?.address}</span>
            </p>
          </LightTooltip>
        )}

        {temple?.brief_note && (
          <LightTooltip title={temple?.brief_note || ""}>
            <p className={styles.tagline}>{temple?.brief_note}</p>
          </LightTooltip>
        )}
      </div>
    </div>
  );
};

export default TempleCard;
